import { css, Theme } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const titleCell = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const disabledBadge = (theme: Theme) => css`
  height: 20px;
  color: ${theme.colors.red};
  background: ${getColorOptions(theme.colors.red).soft};

  .MuiChip-label {
    padding: 0 8px;
    font-size: 11px;
    font-weight: 700;
  }
`

export const warningBadge = (theme: Theme) => css`
  height: 20px;
  color: ${theme.colors.yellow};
  background: ${getColorOptions(theme.colors.yellow).soft};

  .MuiChip-label {
    padding: 0 8px;
    font-size: 11px;
    font-weight: 700;
  }
`

export const modalContainerWrapper = css`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const modalContainer = (theme: Theme) => css`
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 24px;
  padding: 16px;
  width: 560px;
  max-width: calc(100% - 40px);
  box-sizing: border-box;
  max-height: 95vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const modalForm = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const modalTitle = css`
  font-weight: 700;
  text-align: center;
`

export const switchLabel = css`
  margin: 0;
  gap: 8px;
`

export const infoBox = (theme: Theme) => css`
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 16px;
  background: ${getColorOptions(theme.colors.yellow).soft};
`

export const infoBoxText = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
`

export const buttons = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
